import React from 'react';
import { useTheme } from 'styled-components';
import {
  PanelItem,
  PanelItemExternal,
  PanelItemButton,
} from '../styled/SidePanel.styled';
import ExpandableGroup from './ExpandableGroup';

const PanelSectionContent = ({ items, onStripeClick, onPermissionDenied }) => {
  const theme = useTheme();
  const stripeEnabledColor = theme?.name === 'light' ? '#475569' : '#b0bec5';

  if (!items || items.length === 0) return null;

  return (
    <div>
      {items.map((item, idx) => {
        // Expandable sub-group (e.g. Credits, Categories)
        if (item.type === 'expandable') {
          if (item.shown === false) return null;
          return (
            <ExpandableGroup
              key={item.label}
              label={item.label}
              children={item.children}
            />
          );
        }

        // Stripe special handler
        if (item.type === 'stripe') {
          if (item.shown === false) {
            return (
              <PanelItemButton key="stripe" onClick={onPermissionDenied}>
                {item.label}
              </PanelItemButton>
            );
          }
          return (
            <PanelItemButton
              key="stripe"
              onClick={onStripeClick}
              style={{ color: stripeEnabledColor }}
            >
              {item.label}
            </PanelItemButton>
          );
        }

        // External link
        if (item.type === 'external') {
          return (
            <PanelItemExternal
              key={item.link}
              href={item.link}
              target="_blank"
              rel="noopener noreferrer"
            >
              {item.label}
            </PanelItemExternal>
          );
        }

        // Hidden items show permission modal on click
        if (item.shown === false) {
          return (
            <PanelItemButton
              key={item.link || idx}
              onClick={onPermissionDenied}
            >
              {item.label}
            </PanelItemButton>
          );
        }

        // Normal nav link
        return (
          <PanelItem key={item.link} exact to={item.link}>
            {item.label}
          </PanelItem>
        );
      })}
    </div>
  );
};

export default PanelSectionContent;
